import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const Logo: React.FC = () => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className="flex items-center"
    >
      <NavLink to="/" className="flex items-center space-x-2 group">
        <img src="/assets/logo/favicon.png" alt="Hubvex" className="h-8 w-auto drop-shadow-sm" />
        <span className="sm:text-2xl text-xl font-extrabold tracking-tight">
          <span className="text-gray-800">MyAccount</span>
        </span>
      </NavLink>
    </motion.div>
  );
};

export default Logo;